var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '../interceptor/interceptor';
import { TenantType } from '../@types/Tenant';
/**
 * Fetch tenant configuration by tenant ID (URL-encoded query parameter).
 *
 * Follows the backend contract: GET /api/tenants?id={id}
 *
 * @param tenantId - The tenant ID from the session response
 * @returns Tenant configuration including type, endpoints, and settings
 * @throws ApiError if request fails (handled by interceptor)
 */
export const fetchTenant = (tenantId) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield apiClient.get('/tenants', {
        params: { id: tenantId }
    });
    return response.data;
});
export const sleepReferralExclusions = [TenantType.ATHENA];
